import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
  IResult,
} from "../../../../common/interfaces";
import { ICreateMaterial } from "./interfaces/create-material.interface";
import { IUpdateMaterial } from "./interfaces/update-material.interface";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "../../../../services/abstract.service";
import AlternalUnitMeasurementAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/alternal-unit-measure/alternal-unit-measure.entity";
import { query } from "@angular/animations";
import { ICreateUnitMeasure } from "./interfaces/create-unit-measure.interface";
const apiUrl = env.API_MATERIAL_URL;
const moduleName = "material_alternal_unit_measure";

@Injectable({
  providedIn: "root",
})
export class MaterialUnitMeasureService extends AbstractService<
  AlternalUnitMeasurementAttributes,
  ICreateUnitMeasure,
  IUpdateMaterial
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByMaterialId(materialId: string): Observable<IResult<AlternalUnitMeasurementAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${materialId}`;
    return this.http.get<IResult<AlternalUnitMeasurementAttributes>>(API_URL);
  }
}